/**
 * Thin client for backend/campaign_routes.py (Cold Email sequences).
 * Every rule (approval gating, scoping, suppression, send window, caps) is
 * enforced server-side; the UI only hides actions that would be refused.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const APPROVER_ROLES = ['Master Administrator', 'Sales Manager'];

export const STATUS_META = {
  draft: { label: 'Draft', className: 'bg-white/10 text-white/80 border-white/20' },
  pending_approval: { label: 'Pending approval', className: 'bg-amber-500/15 text-amber-300 border-amber-500/30' },
  rejected: { label: 'Rejected', className: 'bg-red-500/15 text-red-300 border-red-500/30' },
  approved: { label: 'Approved', className: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' },
  active: { label: 'Active', className: 'bg-green-500/20 text-green-300 border-green-500/40' },
  paused: { label: 'Paused', className: 'bg-blue-500/15 text-blue-300 border-blue-500/30' },
  archived: { label: 'Archived', className: 'bg-white/5 text-white/50 border-white/10' },
};

export const SKIP_REASONS = {
  not_found: 'not found / not yours',
  archived: 'archived',
  lead_won: 'already won',
  lead_lost: 'marked lost',
  missing_email: 'no email address',
  missing_phone: 'no phone number',
  suppressed: 'opted out (suppressed)',
  already_enrolled: 'already in this sequence',
};

export const STOP_LABELS = {
  replied: 'Replied', unsubscribed: 'Unsubscribed', bounced: 'Bounced', spam_report: 'Spam report',
  manual: 'Stopped manually', lead_won: 'Lead won', lead_lost: 'Lead lost', lead_archived: 'Lead archived',
  missing_contact: 'No contact info', send_failed: 'Send failed', send_interrupted: 'Send interrupted',
  sequence_archived: 'Sequence archived',
};

export const pct = (value) => (value === null || value === undefined ? '—' : `${(value * 100).toFixed(1)}%`);

export async function errorDetail(response, fallback) {
  try {
    const data = await response.json();
    if (typeof data.detail === 'string') return data.detail;
  } catch (e) { /* not JSON */ }
  return fallback;
}

export async function campaignFetch(token, path, { method = 'GET', body } = {}) {
  const response = await fetch(`${API}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!response.ok) throw new Error(await errorDetail(response, 'Request failed'));
  return response.json();
}
